export function KeplrImage() {
    return <img src="https://i.ibb.co.com/rZtNfBq/Keplr-icon-ver-1-3-2-1.png" />
}